import { render, staticRenderFns } from "./AnnouncementPageV2.vue?vue&type=template&id=68c592ca&scoped=true&lang=pug"
import script from "./AnnouncementPageV2.vue?vue&type=script&lang=js"
export * from "./AnnouncementPageV2.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementPageV2.vue?vue&type=style&index=0&id=68c592ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c592ca",
  null
  
)

export default component.exports